import { createSelector } from '@reduxjs/toolkit';

import {
  DEFAULT_SQL_QUOTE_CHARACTER,
  DataSourceType,
  DataSourceTypeDescription,
  JDBC_DATA_SOURCE_FAMILY,
  defaultTypeDescription,
} from 'src/constants/dataSourceTypeDescription';
import { dataSourceTypeDescriptionSelector } from 'src/selectors/dataSourceTypeDescription';
import { Connection } from 'src/store/connections/types';

export const dataSourceNativeQuoteCharacter = (
  typeDescription: DataSourceTypeDescription = defaultTypeDescription,
  type: DataSourceType | null
) => {
  if (type === null) {
    return null;
  }
  const sourceTypeDescription = typeDescription.DATA_SOURCE_TYPES[type];
  if (
    !sourceTypeDescription ||
    sourceTypeDescription.dataSourceFamily !== JDBC_DATA_SOURCE_FAMILY
  ) {
    return null;
  }
  return (
    sourceTypeDescription.identifierQuoteCharacter ||
    DEFAULT_SQL_QUOTE_CHARACTER
  );
};

export const dataSourceNativeQuoteCharacterSelector = (
  type: DataSourceType | null,
  connection: Connection | null
) =>
  createSelector(
    dataSourceTypeDescriptionSelector(connection),
    (typeDescription) => dataSourceNativeQuoteCharacter(typeDescription, type)
  );
